<script>
import SettingsSection from 'dashboard/components/SettingsSection.vue';

export default {
  name: 'FreePBXConfiguration',
  components: {
    SettingsSection,
  },
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<template>
  <div class="mx-8">
    <SettingsSection
      :title="$t('FREEPBX.CONFIGURATION.TITLE')"
      :sub-title="$t('FREEPBX.CONFIGURATION.DESC')"
    >
      <div class="flex flex-col items-center justify-center py-12 space-y-4">
        <div class="text-center">
          <div class="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
            <svg class="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          
          <h3 class="text-2xl font-semibold text-gray-800 mb-2">
            {{ $t('FREEPBX.CONFIGURATION.COMING_SOON') }}
          </h3>
          
          <p class="text-gray-600 max-w-md">
            {{ $t('FREEPBX.CONFIGURATION.COMING_SOON_DESC') }}
          </p>
        </div>
        
        <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 max-w-lg">
          <div class="flex items-start space-x-3">
            <svg class="w-5 h-5 text-blue-600 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
            </svg>
            <div>
              <h4 class="text-sm font-medium text-blue-800">
                {{ $t('FREEPBX.CONFIGURATION.INFO_TITLE') }}
              </h4>
              <p class="text-sm text-blue-700 mt-1">
                {{ $t('FREEPBX.CONFIGURATION.INFO_DESC') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </SettingsSection>
  </div>
</template>